module.exports = __webpack_public_path__ + "static/media/BrooklynHarper.75b6c551.jpg";